import { createGlobalStyle } from "styled-components"
import globals from "../../constants/globals"

const { PRIMARY_COLOR } = globals

const GlobalStyles = createGlobalStyle`
  .cursor-pointer {
    cursor: pointer
  }

  .cursor-default {
    cursor: default;
  }

  .custom-bg {
    background-color: ${PRIMARY_COLOR};
  }

  .custom-color {
    color: ${PRIMARY_COLOR};
  }

  .nav-item {
    margin: 3px;
    &:hover,
    .active {
      background-color: ${PRIMARY_COLOR};
      color: #fff !important;
    }
    a {
      &:hover, &:active, &:focus, .active {
        color: #fff;
        text-decoration: none;
      }
    }
    div {
      padding-left: 5px;
      &:hover, .active {
        color: #fff;
      }
    }
    @media (max-width: 992px) {
      a {
        padding-left: 10px;
      }
    }
  }

  .dropdown-navbar {
    width: 250px;
    li a {
      text-decoration: none;
      &:hover, &:active, &:focus, .active {
        color: #fff !important;
        text-decoration: none;
      }
    }
  }

  body {
    font-family: 'Roboto', sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Roboto', sans-serif;
  }

  .custom-link, a {
    color: ${PRIMARY_COLOR};
    text-decoration: underline;
    cursor: pointer;
    &:hover, &:focus {
      color: #ccc;
      text-decoration: underline;
    }
    /** This is mainly for the DownloadPopover component
     * which has a nested Typography antd component 
     */
    div {
      color: ${PRIMARY_COLOR};
      &:hover, &:focus {
        color: #ccc;
      }
    }
  }

  .participant-preview-text {
    color: #aaa;
    background-color: #fff;
    translate: 0px -30px;
    width: 14%;
    margin: auto;
    text-align: center;
  }

  .participant-preview-border {
    color: #fff;
    border-bottom: 2px dashed #aaa;
  }

  /* Edit Claim Modal Styles */
  .edit-claim-modal {
    min-width: 70%;
    @media screen and (max-width: 992px) {
      min-width: 90%;
    }
  }

  /* Announcement Modal Styles */
  .announcement-modal {
    min-width: 60%;
    @media screen and (max-width: 992px) {
      min-width: 90%;
    }
  }
  .react-quill-style {
    .ql-editor {
      height: 200px;
    }
    margin-top: 0.5rem;
  }

  .close-icon {
    cursor: pointer;
    font-size: 2rem;
    margin-top: 8px;
    color: #000;
  }

  /** Layout */
  #root {
    height: 100%;
  }

  .vh-250 {
    min-height: calc(100vh - 250px);
  }

  .vh-200 {
    min-height: calc(100vh - 200px);
  }

  .vh-150 {
    min-height: calc(100vh - 150px);
  }

 .user-stats {
  background-color: #4D4D4D;
  color: #fff;
 }

 .user-stats-img img {
  color: #fff !important;
 }

 .fs-14 {
    font-size: 14px;
  }
`

export default GlobalStyles
